// import { Box, Grid, styled, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography } from "@mui/material";
import { setLocalStorage } from "../../../../../utils/localStorage";
import { InputField } from "./FormFields/InputField";

interface IForm
{
	setStepCourse: any;
	closeForm(): void;
	componentInputs: any;
	addInput: any;
	handleChange: any;
}

export default function FormMyTribeIs({ setStepCourse, closeForm, componentInputs, addInput, handleChange }: IForm)
{
	function handleStep(step: number)
	{
		setStepCourse(step);
	}

	function handleSubmit(step: number)
	{
		if ((componentInputs[ 2 ].value))
		{
			setStepCourse(step);
			setLocalStorage("mission-nine-inputs", componentInputs);
		}
	}

	return (
		<Box sx={{ flexDirection: "column", display: "flex", width: "100%", maxWidth: "980px", minWidth: { lg: "785px", xl: "906px" } }}>
			<Box sx={{ display: "flex", flexDirection: "column", height: "100%", justifyContent: "space-between" }}>
				<Box
					sx={{ display: "flex", flexDirection: "column", height: "100%", maxHeight: "520px", justifyContent: "space-between" }}
					component="form"
					autoComplete="off"
				>
					<Box sx={{
						display: "flex",
						width: "100%",
						height: "auto",
						m: "0 auto",
						marginTop: "40px",
						marginLeft: "37px",
						border: "1px solid rgba(255, 255, 255, .6)",
						borderRadius: "24px",
						wordBreak: "break-all",
						flexDirection: "column",
						background: "linear-gradient(135.61deg, rgba(239, 239, 239, 0.64) 0%, rgba(239, 239, 239, 0.0816) 98.96%)",
						backdropFilter: "blur(25px)",
						boxShadow: "0px 5px 10px 0px #A7C7E199",
						padding: "24px 32px 13px 32px"
					}}>
						<Box
							sx={{ position: "absolute", top: "22px", right: "22px" }}
							onClick={closeForm}
						>
							<CloseIcon sx={{ fill: "#fff", fontSize: "14px", width: "24px", backgroundColor: "#3E809D", borderRadius: "40px", height: "24px", p: "6px", cursor: "pointer" }} />
						</Box>
						<Box sx={{ margin: "0px" }}>
							<Typography sx={{ font: { lg: "700 18px/31px Lora-Bold", xl: "700 24px/31px Lora-Bold" }, marginLeft: "10px", marginBottom: "17px", color: "#215C75", textAlign: "left", maxHeight: "60px", overflow: "hidden" }}>
								{/* My tribe is... */}
								{componentInputs[ 2 ].title}
							</Typography>
							<InputField
								value={componentInputs[ 2 ].value}
								onChange={(e: any) => handleChange(e.target.value, 2)}
								fullWidth
								autoFocus
								multiline
								rows={3}
								inputProps={{ maxLength: 120 }}
								placeholder={componentInputs[ 2 ].placeholder}
								helperText={`${ componentInputs[ 2 ].value.length }/120 characters`}
							/>
						</Box>
					</Box>
					<Box sx={{ marginLeft: "37px", display: "flex", width: "100%", flexDirection: "row", padding: "15px 0px", justifyContent: "space-between" }}>
						<Box
							sx={{
								position: "relative",
								zIndex: "2000",
								color: "#fff",
								backgroundColor: "#3E809D",
								borderRadius: "30px",
								width: "40px",
								height: "40px",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								"&:hover": { cursor: "pointer" }
							}}
							onClick={() => handleStep(2)}>
							<ArrowBackIosNewIcon />
						</Box>
						<Box
							sx={{
								position: "relative",
								color: "#fff",
								backgroundColor: ((!componentInputs[ 2 ].value) ? "#3E809D80" : "#3E809D"),
								borderRadius: "30px",
								width: "40px",
								height: "40px",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								"&:hover": {
									cursor: ((!componentInputs[ 2 ].value) ? "normal" : "pointer")
								}
							}}
							onClick={() => handleSubmit(4)}>
							<ArrowForwardIosIcon />
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
}
